import { styled, Text, TokenTextAppearance } from '@volkswagen-onehub/components-core';
import React, { useEffect, useState } from 'react';
import { CustomTag } from '../../../components/CustomTag';
import { DisclaimerMarker } from '../../../components/DisclaimerMarker';
import { getLang, getTranslations } from '../../../translations';
import { VehicleCategory } from '../../../types/enums/vehicles';
import { formatCurrency } from '../../../utils/format';
import { getEVIncentives } from '../../../utils/get-ev-incentives';
import { CardetailsInterface } from '../../CarDetails';
import BuildCta from './BuildCta';

export const MsrpContainer = styled.div`
    padding-top: var(--size-dynamic0050);
    padding-bottom: var(--size-dynamic0050);
    display: flex;
    flex-direction: column;
    align-items: start;
    row-gap: ${({theme}) => theme.size.static100};

    // @media screen and (min-width: 560px) {
    //     // display: grid;
    //     grid-template-columns: 50%;
    // }

    // @media screen and (min-width: 1040px) {
    //     display: unset;
    //     grid-row: 1 / 2;
    //     grid-column: 2 / 3;
    // }
`;

interface MsrpInterface extends CardetailsInterface { };

export default ({ vehicle } : MsrpInterface) => {
    const lang = getLang();
    const { disclaimers } = getTranslations();

    const [price, setPrice] = useState<number | null>(null);

    useEffect(() => {
        if(vehicle == null) return;
        let priceValue : number = 0;
        if(vehicle.category == VehicleCategory.NEW) {
            if(vehicle.pcs[lang]) {
                priceValue = Number(vehicle.pcs[lang].price.value);
            }
        }
        else {
            priceValue = Number(vehicle.price);
        }
        setPrice(priceValue);
    }, [vehicle]);

    const incentives = getEVIncentives(vehicle);

    const getCustomTag = () => {
      if (!incentives.count) {
        return null;
      } else {
        const text = incentives?.label?.replace('%%total%%', incentives.total);
        return <CustomTag text={text} bgColor="#d9e6ff" bold />;
      }
    };

    return price ? (
        <MsrpContainer>
          <Text bold appearance={TokenTextAppearance.headline400}>{formatCurrency(price, true, lang)}{incentives.count ? <DisclaimerMarker marker="◊◊" text={disclaimers.electric_pricing} id={`${vehicle.vin}-price`} variant="large" /> : null} </Text>
          { getCustomTag() }
          <BuildCta />
        </MsrpContainer>
    ) : null;
};
